import { render, staticRenderFns } from "./ActionSecurityRole.vue?vue&type=template&id=d2c77a1a&scoped=true"
import script from "./ActionSecurityRole.vue?vue&type=script&lang=js"
export * from "./ActionSecurityRole.vue?vue&type=script&lang=js"
import style0 from "./ActionSecurityRole.vue?vue&type=style&index=0&id=d2c77a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c77a1a",
  null
  
)

export default component.exports